import { useEffect } from "react";
import * as CookieConsent from "vanilla-cookieconsent";

// Configurazione GDPR-compliant per il banner cookie di Estetica Elite.
// Categoria 'necessary' sempre attiva, 'functionality' richiede consenso
// esplicito (Google Maps, Google Fonts).
export default function CookieConsentBanner() {
  useEffect(() => {
    try {
      CookieConsent.run({
        cookie: {
          name: "cc_cookie",
          sameSite: "Lax",
          secure: true,
          expiresAfterDays: 182,
        },
        categories: {
          necessary: {
            enabled: true,
            readOnly: true,
          },
          functionality: {
            enabled: false,
            readOnly: false,
            services: {
              googleMaps: { label: "Google Maps" },
              googleFonts: { label: "Google Fonts" },
            },
          },
        },
        guiOptions: {
          consentModal: {
            layout: "box",
            position: "bottom right",
            equalWeightButtons: true,
            flipButtons: false,
          },
          preferencesModal: {
            layout: "box",
            position: "right",
            equalWeightButtons: true,
            flipButtons: false,
          },
        },
        language: {
          default: "it",
          autoDetect: "document",
          translations: {
            it: {
              consentModal: {
                title: "Utilizziamo i cookie",
                description:
                  "Utilizziamo cookie tecnici per il corretto funzionamento del sito e, previo tuo consenso, cookie di funzionalità per servizi di terze parti come Google Maps. Puoi accettare, rifiutare o personalizzare le tue scelte in qualsiasi momento. Per maggiori informazioni leggi la nostra <a href='/cookie-policy'>Cookie Policy</a>.",
                acceptAllBtn: "Accetta tutti",
                acceptNecessaryBtn: "Rifiuta tutti",
                showPreferencesBtn: "Gestisci preferenze",
              },
              preferencesModal: {
                title: "Preferenze cookie",
                acceptAllBtn: "Accetta tutti",
                acceptNecessaryBtn: "Rifiuta tutti",
                savePreferencesBtn: "Accetta selezionati",
                closeIconLabel: "Chiudi",
                sections: [
                  {
                    title: "Le tue preferenze sui cookie",
                    description:
                      "In questa pagina puoi gestire le tue preferenze sui cookie utilizzati dal sito. Per maggiori informazioni leggi la nostra <a href='/cookie-policy'>Cookie Policy</a>.",
                  },
                  {
                    title: "Cookie strettamente necessari",
                    description:
                      "Questi cookie sono essenziali per il funzionamento del sito e non possono essere disattivati.",
                    linkedCategory: "necessary",
                  },
                  {
                    title: "Cookie di funzionalità",
                    description:
                      "Questi cookie permettono di abilitare funzioni avanzate del sito come la mappa interattiva di Google Maps.",
                    linkedCategory: "functionality",
                  },
                  {
                    title: "Maggiori informazioni",
                    description:
                      "Per ulteriori dettagli su come gestiamo i tuoi dati personali, leggi la nostra <a href='/privacy-policy'>Privacy Policy</a> e <a href='/cookie-policy'>Cookie Policy</a>.",
                  },
                ],
              },
            },
          },
        },
      });
    } catch (e) {
      console.error("CookieConsent failed to init:", e);
    }
  }, []);

  return null;
}
